/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  // Fase 2 · actualiza solo feature_permissions del agente · usa endpoint update existente.
  updatePermissions(agentId, featurePermissions) {
    return axios.patch(`${this.url}/${agentId}`, {
      agent: { feature_permissions: featurePermissions },
    });
  }
}

export default new Agents();
